export const SSO_BUSINESS_LOGIN_PAYLOAD_KEY = "insaf-sso-business-login-payload";

export const SSO_BUSINESS_LOGIN_LAST_ERROR_KEY = "insaf-sso-business-login-last-error";

export interface ISsoBusinessLoginRetryPayload {
	userId: string;
	beneficiaryFirmId: string;
}
